import { useState } from "react";
import { Link } from "react-router-dom";
import { feedPosts, siteName } from "@/mocks/guawa";

export default function Feed() {
  const [liked, setLiked] = useState<string[]>([]);
  const [poked, setPoked] = useState<string[]>([]);

  const toggleLike = (id: string) => {
    setLiked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  };
  const togglePoke = (id: string) => {
    setPoked((p) => (p.includes(id) ? p.filter((x) => x !== id) : [...p, id]));
  };

  const list = [...feedPosts];

  return (
    <section id="site-feed" className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">瓜友热议</span>
          <h2 className="mt-1 text-2xl font-extrabold tracking-tight text-ink-900 md:text-3xl">最近都在聊什么</h2>
          <p className="mt-2 text-sm text-ink-500">新鲜热辣的讨论现场，进来插个嘴、点个赞。</p>
        </div>
        <Link
          to="/topics"
          className="inline-flex items-center gap-2 rounded-full bg-ink-800 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-ink-700 whitespace-nowrap"
        >
          看更多热议 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((p) => {
          const isLiked = liked.includes(p.id);
          const isPoked = poked.includes(p.id);
          const likeCount = p.likes + (isLiked ? 1 : 0);
          return (
            <article
              key={p.id}
              className="flex flex-col rounded-2xl border border-cream-200 bg-white p-5 transition-all hover:-translate-y-1 hover:border-primary-200 hover:shadow-lift"
            >
              <div className="flex items-center justify-between text-xs">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-2.5 py-1 font-medium text-primary-700">
                  <i className={`${p.catId === "keji" ? "ri-cpu-line" : "ri-pages-line"}`}></i> {p.cat}
                </span>
                {p.badge && (
                  <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-600">
                    <i className="ri-fire-line"></i> {p.badge}
                  </span>
                )}
              </div>

              <h3 className="mt-3 text-base font-bold leading-snug text-ink-900">
                <Link to="/topic/discuss-2026" className="transition-colors hover:text-primary-700">
                  {p.title}
                </Link>
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-500">{p.excerpt}</p>

              <div className="mt-4 flex items-center gap-2 border-t border-cream-100 pt-3 text-xs text-ink-400">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-cream-200 text-sm">
                  {p.author.slice(0, 1)}
                </span>
                <span className="max-w-[110px] truncate font-medium text-ink-600">{p.author}</span>
                <span className="ml-auto">·</span>
                <span className="whitespace-nowrap">{p.time}</span>
              </div>

              <div className="mt-3 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => toggleLike(p.id)}
                  className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors whitespace-nowrap ${
                    isLiked
                      ? "bg-primary-500 text-white"
                      : "bg-primary-50 text-primary-700 hover:bg-primary-100"
                  }`}
                >
                  <i className={isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"}></i>
                  {likeCount.toLocaleString()}
                </button>
                <Link
                  to="/topic/discuss-2026"
                  className="inline-flex items-center gap-1.5 text-xs font-medium text-ink-500 transition-colors hover:text-primary-700 whitespace-nowrap"
                >
                  <i className="ri-chat-3-line"></i> {p.comments.toLocaleString()} 条讨论
                </Link>
                <button
                  type="button"
                  onClick={() => togglePoke(p.id)}
                  title="拍拍瓜友"
                  className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1.5 text-sm transition-colors ${
                    isPoked ? "text-accent-500" : "text-ink-400 hover:text-accent-500"
                  }`}
                  aria-label="围观支持"
                >
                  <i className={isPoked ? "ri-hand-heart-fill" : "ri-hand-heart-line"}></i>
                </button>
              </div>
            </article>
          );
        })}

        {/* 引导投稿卡片 */}
        <aside className="flex flex-col items-start justify-center rounded-2xl bg-primary-600 p-6 text-white">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/15 text-2xl">
            <i className="ri-megaphone-line"></i>
          </span>
          <h3 className="mt-4 text-lg font-bold">有瓜想爆？有料要投？</h3>
          <p className="mt-2 text-sm leading-relaxed text-primary-50/90">
            分享你的见闻与观点，{siteName} 编辑将择优整理并上架热议专区。
          </p>
          <Link
            to="/contact"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-cream-100 whitespace-nowrap"
          >
            <i className="ri-edit-2-line"></i> 投稿参与讨论
          </Link>
        </aside>
      </div>
    </section>
  );
}